import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  inquiryList: [], 
  inquiryArr: [],
  inquiryArray: [],
  inquiryID: '',
  selectedInquiry: null,
  selectedRep: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.inquiryList = [];
    state.inquiryArr = [];
    state.inquiryArray = [];
    state.inquiryID = '';
    state.selectedInquiry = null;
    state.selectedRep = null;
    state.isEditing = false;
  },
  SET_SELECTED_INQUIRY(state, inquiry) {
    state.selectedInquiry = inquiry;
    state.isEditing = true;
  },
  SET_SELECTED_REP(state, rep) {
    state.selectedRep = rep;
  },
  LIST_INQUIRIES(state, inquiries) {
    state.inquiryList = inquiries;
  },
  INQUIRY_ARRAY(state, inquiryArray){
    state.inquiryArray = inquiryArray;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){
    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createCustomerInquiry({ commit,state }, formData) {
    return axios.post('api/v1/create-customer-inquiry/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchCustomerInquiries({ commit,state }, formData) {
    state.inquiryArr = [];
    axios.post(`api/v1/get-customer-inquiries/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.inquiryArr.push((response.data[i].customer_name + " - Subject: " + response.data[i].subject));
      }
      commit('LIST_INQUIRIES', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchCustomerInquiry({ commit,state }, formData) {
    axios.post(`api/v1/get-customer-inquiries/`,formData)
    .then((response)=>{
        const selectedRep = (response.data.assigned_to != null) ? (response.data.assigned_to.name  + " - Email: " + response.data.assigned_to.email)  : "";
        state.selectedInquiry = response.data;
        commit('SET_SELECTED_REP',selectedRep);
        commit('SET_SELECTED_INQUIRY',response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedInquiry({ commit, state }, option){
    state.inquiryArray = [];
    const selectedInquiry = state.inquiryList.find(inquiry => (inquiry.customer_name + " - Subject: " + inquiry.subject) === option);
    if (selectedInquiry) {
        state.inquiryID = selectedInquiry.inquiry_id;
        state.inquiryArray = [...state.inquiryArray, selectedInquiry];
    }
    commit('INQUIRY_ARRAY', state.inquiryArray);
      
  },

  async updateCustomerInquiry({ commit,state }, formData) {
    return axios.put(`api/v1/update-customer-inquiry/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteCustomerInquiry({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Inquiry?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Inquiry!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-customer-inquiry/`,formData)
        .then((response)=>{
          if(response.data.msg == "Success"){
              Swal.fire("Poof! Inquiry removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Inquiry",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Inquiry has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  